<template>
  <Toast
    :position="position"
    :pt="{ root: { class: 'prime-toast' } }"
  >
    <template #message="{ message }">
      <RriIcon
        v-if="messageIcon(message)"
        :icon="messageIcon(message)"
        size="md"
        :class="['prime-toast__icon', `prime-toast__icon--${message?.severity || 'info'}`]"
      />
      <div class="p-toast-message-text">
        <span
          v-if="message?.summary"
          class="p-toast-summary"
        >
          {{ message.summary }}
        </span>
        <div
          v-if="message?.detail"
          class="p-toast-detail"
        >
          {{ message.detail }}
          <RouterLink
            v-if="message?.link"
            :to="message.link.to"
            class="prime-toast__link"
          >
            {{ message.link.label }}
            <RriIcon
              icon="chevron-right"
              size="sm"
              class="prime-toast__link-icon"
            />
          </RouterLink>
        </div>
      </div>
    </template>
    <template #closeicon="{ class: iconClass }">
      <RriIcon
        icon="close-circle"
        size="md"
        :class="iconClass"
      />
    </template>
  </Toast>
</template>

<script setup>
import Toast from 'primevue/toast'
import RriIcon from '@/components/rri/RriIcon.vue'

defineProps({
  position: {
    type: String,
    default: 'bottom-center',
    validator: value =>
      ['top-left', 'top-center', 'top-right', 'bottom-left', 'bottom-center', 'bottom-right', 'center'].includes(value)
  }
})

const DEFAULT_ICON_MAP = {
  success: 'check-circle-filled',
  error: 'forbidden-filled',
  warn: 'info-circle-filled',
  info: 'check-circle-filled'
}

function messageIcon(message) {
  const severity = message?.severity || 'info'
  return DEFAULT_ICON_MAP[severity] || ''
}
</script>
